module.exports = __webpack_public_path__ + "img/logo-edeka-full@3x.16bcdca6.png";